import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';
import Chip from '@/components/General/Chip';
import CutCard from '@/components/General/CutCard';

export const announcementStatus = { queued: 'Scheduled / queued', sending: 'Sending', complete: 'Finished', canceled: 'Canceled', failed: 'Needs attention', pending: 'Awaiting confirmation', accepted: 'Accepted by email provider', delivered: 'Delivery confirmed', unreachable: 'No alert delivery route', unknown: 'Could not confirm' };
export const channelLabel = { push: 'Push notification', sms: 'SMS', email: 'Email', unreachable: 'No alert delivery route' };

export function AnnouncementSection({ title, description, icon, children, testID }) {
    return <CutCard style={announcementStyles.card} contentStyle={announcementStyles.cardContent} testID={testID}>
        <View style={announcementStyles.row}>
            {!!icon && <View style={announcementStyles.icon}><Unicon name={icon} size={20} colorVariant="connect" /></View>}
            <View style={announcementStyles.grow}>
                <Text style={announcementStyles.heading}>{title}</Text>
                {!!description && <Text style={announcementStyles.caption}>{description}</Text>}
            </View>
        </View>
        {children}
    </CutCard>;
}

export function AnnouncementMetrics({ summary = {}, preview = false }) {
    const items = preview ? [
        ['push', 'Push', 'notifications-outline', 'connect'], ['sms', 'SMS', 'chatbubble-outline', 'primary'], ['email', 'Email', 'mail-outline', 'info'], ['unreachable', 'No alert route', 'alert-circle-outline', 'warning'],
    ] : [
        ['delivered', 'Confirmed', 'checkmark-circle-outline', 'success'], ['accepted', 'Email accepted', 'mail-outline', 'info'], ['pending', 'In progress', 'time-outline', 'connect'], ['unreachable', 'No alert route', 'alert-circle-outline', 'warning'], ['unknown', 'Unconfirmed', 'help-circle-outline', 'textSecondary'],
    ];
    return <View style={announcementStyles.metrics}>{items.map(([key, label, icon, color]) => <View key={key} style={announcementStyles.metric} testID={`announcement-count-${key}`}>
        <Unicon name={icon} size={18} colorVariant={color} />
        <Text style={announcementStyles.metricValue}>{(summary[key] || 0).toLocaleString()}</Text>
        <Text style={announcementStyles.caption}>{label}</Text>
    </View>)}</View>;
}

export function AnnouncementStatus({ status }) {
    const color = ['failed', 'unreachable'].includes(status) ? 'warning' : status === 'delivered' || status === 'complete' ? 'success' : status === 'unknown' || status === 'canceled' ? 'textSecondary' : 'connect';
    return <Chip colorVariant={color}>{announcementStatus[status] || status}</Chip>;
}

export const announcementStyles = StyleSheet.create(({ colors, fonts, spacing, typography, roundness, shadows }, { screen }) => ({
    page: { flex: 1, backgroundColor: colors.background },
    content: { width: '100%', maxWidth: 900, alignSelf: 'center', padding: screen.width < 600 ? spacing.sm : spacing.md, paddingBottom: spacing.xxl, gap: spacing.md },
    card: { boxShadow: shadows.card },
    cardContent: { padding: screen.width < 600 ? spacing.md : spacing.lg, gap: spacing.md },
    heading: { color: colors.text, fontFamily: fonts.bold, fontSize: typography.h3 },
    title: { color: colors.text, fontFamily: fonts.bold, fontSize: typography.h1 },
    text: { color: colors.text, fontFamily: fonts.body, fontSize: typography.body, lineHeight: 23 },
    caption: { color: colors.textSecondary, fontFamily: fonts.body, fontSize: typography.caption, lineHeight: 19 },
    accent: { color: colors.connect, fontFamily: fonts.bold, fontSize: typography.caption },
    row: { flexDirection: 'row', alignItems: 'center', gap: spacing.sm, flexWrap: 'wrap' },
    grow: { flex: 1, minWidth: 120, gap: spacing.xs },
    icon: { width: 42, height: 42, borderRadius: roundness.md, backgroundColor: colors.connectContainer, alignItems: 'center', justifyContent: 'center' },
    metrics: { flexDirection: 'row', flexWrap: 'wrap', gap: spacing.sm },
    metric: { flex: 1, minWidth: 110, backgroundColor: colors.surfaceVariant, padding: spacing.md, borderRadius: roundness.md, gap: spacing.sm },
    metricValue: { color: colors.text, fontFamily: fonts.bold, fontSize: typography.hero, fontVariant: ['tabular-nums'] },
    preview: { padding: spacing.md, borderRadius: roundness.md, backgroundColor: colors.surfaceVariant, gap: spacing.sm },
    error: { color: colors.error, fontFamily: fonts.body, fontSize: typography.caption },
    center: { padding: spacing.xl, gap: spacing.md, alignItems: 'center' },
}));
